import api from './api';

export const paymentFileService = {
  /**
   * Get payment file configuration data.
   */
  getConfig: async () => {
    const response = await api.get('/admin/payment-file');
    return response.data;
  },

  /**
   * Add a new company.
   */
  addCompany: async (companyShort, companyLong) => {
    const response = await api.post('/admin/payment-file/company', {
      companyShort,
      companyLong
    });
    return response.data;
  },

  /**
   * Delete a company.
   */
  deleteCompany: async (id) => {
    const response = await api.delete(`/admin/payment-file/company/${id}`);
    return response.data;
  },

  /**
   * Add a new fund type.
   */
  addFundType: async (fundTypeShort, fundTypeLong) => {
    const response = await api.post('/admin/payment-file/fund-type', {
      fundTypeShort,
      fundTypeLong
    });
    return response.data;
  },

  /**
   * Delete a fund type.
   */
  deleteFundType: async (id) => {
    const response = await api.delete(`/admin/payment-file/fund-type/${id}`);
    return response.data;
  },

  /**
   * Manually trigger payment file generation.
   */
  generateFiles: async () => {
    const response = await api.post('/admin/payment-file/generate', {});
    return response.data;
  }
};